// Named background themes for text stories — keys MUST match the backend-accepted set
// (violet, aurora, ocean, midnight, ember). Any other value is rejected with 422 "Unknown background theme".
export const STORY_BGS = [
  { key: "violet", css: "linear-gradient(135deg,#7C3AED,#4F1D96)" },
  { key: "aurora", css: "linear-gradient(135deg,#01FABD,#0B7285)" },
  { key: "ocean", css: "linear-gradient(135deg,#3591F4,#1E3A8A)" },
  { key: "midnight", css: "linear-gradient(135deg,#1E293B,#05070E)" },
  { key: "ember", css: "linear-gradient(135deg,#F59E0B,#B91C1C)" },
];

export function bgCss(bg) {
  const found = STORY_BGS.find((b) => b.key === bg);
  if (found) return found.css;
  if (typeof bg === "string" && (bg.startsWith("#") || bg.startsWith("linear") || bg.startsWith("rgb"))) return bg;
  return STORY_BGS[0].css;
}

export const STORY_AUDIENCES = [
  { key: "contacts", label: "Contacts" },
  { key: "circles", label: "Circles" },
  { key: "bloq", label: "A BLOQ" },
];
